import { getAdjustedTimeSegment } from "./utils";

function TimeView({time}) {
  let hoursRaw = new Date(time).getHours();
  let hours = hoursRaw > 12 ? hoursRaw-12 : hoursRaw;
  let minutes = new Date(time).getMinutes();
  let AMPM = hoursRaw > 12 ? "PM" : "AM"
  return getAdjustedTimeSegment(hours)+":"+getAdjustedTimeSegment(minutes)+AMPM;
}
export default TimeView;